import { render, staticRenderFns } from "./AppInBehandeling.vue?vue&type=template&id=5c1e6595&scoped=true&"
import script from "./AppInBehandeling.ts?vue&type=script&lang=ts&"
export * from "./AppInBehandeling.ts?vue&type=script&lang=ts&"
import style0 from "./AppInBehandeling.scss?vue&type=style&index=0&id=5c1e6595&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e6595",
  null
  
)

export default component.exports